import { render, staticRenderFns } from "./ModuleClientBuyProduct.vue?vue&type=template&id=8dba5f5c&scoped=true&lang=pug&"
import script from "./ModuleClientBuyProduct.vue?vue&type=script&lang=js&"
export * from "./ModuleClientBuyProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModuleClientBuyProduct.vue?vue&type=style&index=0&id=8dba5f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dba5f5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
